import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';

/**
 * Vehicle insurance claim DTO for lists
 */
@CaslSubject(AppSubjectEnum.VEHICLE_INSURANCE_CLAIM)
export class VehicleInsuranceClaimListDto extends BaseDto {
	mobileTitle = (): string | null => {
		return ``;
	};

	mobileSubtitle = (): string | null => {
		return ``;
	};
}
